import { makeAutoObservable } from 'mobx'
import { type IResponseCampaignsByIdMessage } from 'entities/Campaign'
import { Contact } from 'entities/Contacts/model/Contact'

export class CampaignFailedMessage {
  contact
  constructor(public origin: IResponseCampaignsByIdMessage) {
    makeAutoObservable(this)

    this.contact = new Contact(origin.contact)
  }

  get id() {
    return this.origin.id
  }

  get email() {
    return this.origin.contact.email
  }

  get failed_reason() {
    return this.transformFailedReason(this.origin.failed_reason)
  }

  get last_step_id() {
    return null
  }

  get steps_count() {
    return 0
  }

  get contact_has_replied() {
    return false
  }

  get team_id() {
    return this.origin.team_id
  }

  get isDisabled() {
    return this.contact.isDisabled
  }

  transformFailedReason = (error: string): string => {
    const regExp = new RegExp('Learn more <a (.*?)>here</a>')
    return error.replace(regExp, '<a target="_blank" $1>Learn more</a>')
  }
}
